import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OktaService } from './okta.service';

@Injectable({
  providedIn: 'root',
})
export class FaqCategoryService {
  constructor(public http: HttpClient, public okta: OktaService) {}

  public addFAQCategory(faqId: string, categoryId: string): Observable<any> {
    const oktaToken = this.okta.getIdToken();
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: oktaToken ? oktaToken : '',
    });
    const body = {
      query: `
      mutation{
        createFAQCategory(input:{fAQCategoryFaqId:"${faqId}", fAQCategoryCategoryId:"${categoryId}"}){id}
      }
    `,
    };
    return this.http.post(environment.appsyncBaseUrl, body, {
      headers: header,
    });
  }

  public deleteFAQCategory(id: string): Observable<any> {
    const oktaToken = this.okta.getIdToken();
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: oktaToken ? oktaToken : '',
    });
    const body = {
      query: `
      mutation{
        deleteFAQCategory(input:{id:"${id}"}){id}
      }
    `,
    };
    return this.http.post(environment.appsyncBaseUrl, body, {
      headers: header,
    });
  }
}
